const myAccount = {
  availableWhenAccountIsApproved: 'Available when account is approved',
  freeSanctionChecksAndPepScreenings: 'Free sanction checks and PEP screenings',
  myAccount: 'My Account',
  requestApproved: 'Your request has been approved',
  requestCompleted: 'Your account is active',
  requestPending: 'Your request is pending status for review',
  requestRejected: 'Your request has been rejected',
  walletAssignmentInProgress: 'Please wait, we are configuring your data',
  walletCreationFailed: 'An error occurred, please try again later',
  verifyAllProvidedDocuments: 'Verify all provided documents',
  yourOnboardingData: 'Your onboarding Data',
};

export default myAccount;
